import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { lookInsideImages } from '../data/lookInside';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const goTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(lookInsideImages.length - 1, index));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
  }, []);
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (index !== active) setActive(index);
  };
  return <section aria-labelledby="look-inside-title" className="py-10 px-4 sm:px-6 bg-brand-alt border-b border-gray-200" data-id="element-114" data-mp="1mvs0prte9o7a">
      <div className="text-center mb-6 max-w-2xl mx-auto" data-id="element-115" data-mp="1dxptguj2hzbk">
        <p className="text-xs font-black text-brand-gold uppercase tracking-widest mb-2" data-id="element-116" data-mp="1dz9cgsw3yoh1">
          LOOK INSIDE
        </p>
        <h2 id="look-inside-title" className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-117" data-mp="61ckp1rqiagl">
          Discover What's Inside PHYSIO READY™
        </h2>
        <p className="text-sm text-brand-muted leading-relaxed" data-id="element-118" data-mp="f2snoog7zaas">
          Clinical assessments, visual exercise prescriptions, rehabilitation
          programs, treatment planning, exercise progressions, patient
          education, home exercise guidance, progress tracking, SOAP notes,
          clinical documentation and structured patient care resources.
        </p>
      </div>

      <div className="relative max-w-xl mx-auto" role="region" aria-roledescription="carousel" aria-label="Inside Physio Ready" data-id="element-119" data-mp="3sgdtdpjt9tsc">
        <div ref={trackRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory rounded-xl border-2 border-brand-navy/15 bg-white shadow-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-120" data-mp="2zrzwjd4gl3id">
          {lookInsideImages.map((img, i) => <a key={img.src} href="#pricing" className="w-full shrink-0 snap-center block" aria-label={`Slide ${i + 1} of ${lookInsideImages.length}`} data-id="element-121" data-mp="1dewucslfubou" data-mpi={i}>
              <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} draggable={false} className="w-full h-auto object-contain select-none" data-id="element-122" data-mp="kqras964esql" />
            </a>)}
        </div>

        <button type="button" onClick={() => goTo(active - 1)} disabled={active === 0} aria-label="Previous image" className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-navy text-white flex items-center justify-center shadow-lg transition-[opacity,background-color] duration-150 hover:bg-brand-gold hover:text-brand-navy disabled:opacity-0" data-id="element-123" data-mp="yqa6g2hqwbm0">
          <ChevronLeftIcon className="w-5 h-5" data-id="element-124" data-mp="2fab0kjdtb1ay" />
        </button>
        <button type="button" onClick={() => goTo(active + 1)} disabled={active === lookInsideImages.length - 1} aria-label="Next image" className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-navy text-white flex items-center justify-center shadow-lg transition-[opacity,background-color] duration-150 hover:bg-brand-gold hover:text-brand-navy disabled:opacity-0" data-id="element-125" data-mp="2aija08unovkt">
          <ChevronRightIcon className="w-5 h-5" data-id="element-126" data-mp="1rm9lssq1ion3" />
        </button>

        <div className="flex items-center justify-center gap-2 mt-4" data-id="element-127" data-mp="1njwqyzcu0b53">
          {lookInsideImages.map((img, i) => <button key={img.src} type="button" onClick={() => goTo(i)} aria-label={`Go to image ${i + 1}`} aria-current={i === active} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ${i === active ? 'w-7 bg-brand-navy' : 'w-2.5 bg-brand-navy/25 hover:bg-brand-navy/50'}`} data-id="element-128" data-mp="3lxevadnt5vac" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}